import { singleton, collect, delay, toList, map, toArray } from "../Docs/fable_modules/fable-library.3.7.1/Seq.js";
import { curry, createObj } from "../Docs/fable_modules/fable-library.3.7.1/Util.js";
import { class_type } from "../Docs/fable_modules/fable-library.3.7.1/Reflection.js";
import { Aggregation__asString, ColumnDefOptionProp$1 } from "./Types.fs.js";
import { printf, toFail } from "../Docs/fable_modules/fable-library.3.7.1/String.js";
import { cons } from "../Docs/fable_modules/fable-library.3.7.1/List.js";

export function nativeColumnDefs(columnDefs) {
    return toArray(map((colDef) => createObj(toList(delay(() => collect((option) => ((option.tag === 1) ? singleton(["accessorKey", option.fields[0]]) : ((option.tag === 2) ? singleton(["accessorFn", option.fields[0]]) : ((option.tag === 3) ? singleton(["header", option.fields[0]]) : ((option.tag === 5) ? singleton(["footer", option.fields[0]]) : ((option.tag === 4) ? singleton(["header", option.fields[0]]) : ((option.tag === 6) ? singleton(["footer", option.fields[0]]) : ((option.tag === 7) ? singleton(["cell", option.fields[0]]) : ((option.tag === 9) ? singleton(["columns", nativeColumnDefs(option.fields[0])]) : ((option.tag === 10) ? singleton(["aggregationFn", option.fields[0]]) : ((option.tag === 11) ? singleton(["enableGrouping", option.fields[0]]) : ((option.tag === 8) ? singleton(["aggregatedCell", option.fields[0]]) : ((option.tag === 12) ? singleton(["size", option.fields[0]]) : ((option.tag === 13) ? singleton(["minSize", option.fields[0]]) : ((option.tag === 14) ? singleton(["maxSize", option.fields[0]]) : ((option.tag === 15) ? singleton(["enableHiding", option.fields[0]]) : ((option.tag === 16) ? singleton(["sortingFn", option.fields[0]]) : ((option.tag === 17) ? singleton(["sortDescFirst", option.fields[0]]) : ((option.tag === 18) ? singleton(["enableSorting", option.fields[0]]) : ((option.tag === 19) ? singleton(["enableMultiSort", option.fields[0]]) : ((option.tag === 20) ? singleton(["invertSorting", option.fields[0]]) : ((option.tag === 21) ? singleton(["sortUndefined", option.fields[0]]) : singleton(["id", option.fields[0]])))))))))))))))))))))), colDef)))), columnDefs));
}

export class columnDef {
    constructor() {
    }
}

export function columnDef$reflection() {
    return class_type("Feliz.TanStack.Table.ColumnDef.columnDef", void 0, columnDef);
}

export function columnDef_id_Z721C83C5(s) {
    return new ColumnDefOptionProp$1(0, s);
}

export function columnDef_accessorKey_Z721C83C5(s) {
    return new ColumnDefOptionProp$1(1, s);
}

export function columnDef_accessorFn_77A7E8C8(fn) {
    return new ColumnDefOptionProp$1(2, fn);
}

export function columnDef_header_Z721C83C5(s) {
    return new ColumnDefOptionProp$1(3, s);
}

export function columnDef_header_Z5FD1F5D2(fn) {
    return new ColumnDefOptionProp$1(4, (props) => {
        const table = { ...props.table, _obj: props.table, Data: props.table.options.data };
        props.table = table;
        return fn(props);
    });
}

export function columnDef_footer_Z721C83C5(s) {
    return new ColumnDefOptionProp$1(5, s);
}

export function columnDef_footer_Z5FD1F5D2(fn) {
    return new ColumnDefOptionProp$1(6, fn);
}

export function columnDef_cell_Z1DDB00E5(fn) {
    return new ColumnDefOptionProp$1(7, (props) => {
        const table = { ...props.table, _obj: props.table, Data: props.table.options.data };
        props.table = table;
        return fn(props);
    });
}

export function columnDef_aggregationFn_Z6F01443(fn) {
    return new ColumnDefOptionProp$1(10, curry(2, fn));
}

export function columnDef_aggregationFn_Z71F7D04B(aggregation) {
    return new ColumnDefOptionProp$1(10, Aggregation__asString(aggregation));
}

export function columnDef_aggregatedCell_Z1DDB00E5(fn) {
    return new ColumnDefOptionProp$1(8, (props) => {
        const table = { ...props.table, _obj: props.table, Data: props.table.options.data };
        props.table = table;
        return fn(props);
    });
}

export function columnDef_enableGrouping_Z1FBCCD16(enableGrouping) {
    return new ColumnDefOptionProp$1(11, enableGrouping);
}

export function columnDef_columns_Z2906D979(columnDef_1) {
    return new ColumnDefOptionProp$1(9, columnDef_1);
}

export function columnDef_size_Z524259A4(size) {
    return new ColumnDefOptionProp$1(12, size);
}

export function columnDef_minSize_Z524259A4(minSize) {
    return new ColumnDefOptionProp$1(13, minSize);
}

export function columnDef_maxSize_Z524259A4(maxSize) {
    return new ColumnDefOptionProp$1(14, maxSize);
}

export function columnDef_enableHiding_Z1FBCCD16(hiding) {
    return new ColumnDefOptionProp$1(15, hiding);
}

export function columnDef_sortingFn_34CAEEB1(fn) {
    return new ColumnDefOptionProp$1(16, curry(3, fn));
}

export function columnDef_sortingFn_Z721C83C5(sortingFnKey) {
    return new ColumnDefOptionProp$1(16, sortingFnKey);
}

export function columnDef_sortDescFirst_Z1FBCCD16(sortDescFirst) {
    return new ColumnDefOptionProp$1(17, sortDescFirst);
}

export function columnDef_enableSorting_Z1FBCCD16(enableSorting) {
    return new ColumnDefOptionProp$1(18, enableSorting);
}

export function columnDef_enableMultiSort_Z1FBCCD16(enableMultiSort) {
    return new ColumnDefOptionProp$1(19, enableMultiSort);
}

export function columnDef_invertSorting_Z1FBCCD16(invertSorting) {
    return new ColumnDefOptionProp$1(20, invertSorting);
}

export function columnDef_sortUndefined_Z524259A4(sortUndefined) {
    switch (sortUndefined) {
        case -1:
        case 1: {
            break;
        }
        default: {
            toFail(printf("sortUndefined must be either -1 or 1"));
        }
    }
    return new ColumnDefOptionProp$1(21, sortUndefined);
}

export class ColumnHelper {
    constructor() {
    }
}

export function ColumnHelper$reflection() {
    return class_type("Feliz.TanStack.Table.ColumnDef.ColumnHelper", void 0, ColumnHelper);
}

export function ColumnHelper_accessor_10721996(accessor, columnDefs) {
    return cons(columnDef_accessorKey_Z721C83C5(accessor), columnDefs);
}

export function ColumnHelper_accessor_36841BC5(accessorFn, columnDefs) {
    return cons(columnDef_accessorFn_77A7E8C8(accessorFn), columnDefs);
}

export function ColumnHelper_createColumnHelper_Z2906D979(columnDefs) {
    return columnDefs;
}

//# sourceMappingURL=ColumnDef.fs.js.map
